export const PrincipleType = {
  AI: "ai",
  ALGORITHMS: "algorithms",
  API: "api",
  NETWORKING: "networking",
  NULL_HANDLING: "null handling",
  NAMING_CONVENTIONS: "naming conventions",
  CODE_STYLE: "code style",
  CONCURRENCY: "concurrency",
  SECURITY: "security",
  CACHING: "caching",
  PERFORMANCE_OPTIMIZATION: "performance optimization",
  CI_CD: "ci/cd",
  DOCUMENTATION: "documentation",
  LOGGING: "logging",
  ERROR_HANDLING: "error handling",
  OBSERVABILITY: "observability",
  DATABASE: "database",
  MIGRATIONS: "migrations",
  TESTING: "testing",
  CONFIGURATIONS: "configurations",
  NEST_JS: "nestjs",
  VUE: "vue",
  NEXT: "next",
  ANGULAR: "angular",
  REACT: "react",
  TEMPORAL: "temporal",
  DBT: "dbt",
  CELERY: "celery",
  PYTORCH: "pytorch",
  SPRING: "spring"
} as const

export type PrincipleType = (typeof PrincipleType)[keyof typeof PrincipleType]

export interface Comment {
  author: string
  comment: string
  createdAt: string
}

export interface Scope {
  repositoryId: string
  repositoryName: string
  globPath: string
}

export interface Discussion {
  id: string
  prTitle: string
  createdAt: string
  commentedCode: string
  prFile: string
  startLine: number | null
  endLine: number | null
  commitSha: string
  comments: Comment[]
}

export interface Principle {
  id: string
  title: string
  description: string
  label: PrincipleType
  discussions: Discussion[]
  scopes: Scope[]
  enabled: boolean
  createdAt: string
  updatedAt: string
  generatedTitle: string
  generatedDescription: string
}
